import { render, staticRenderFns } from "./Umsätze.vue?vue&type=template&id=4b4a2ac0&"
import script from "./Umsätze.vue?vue&type=script&lang=js&"
export * from "./Umsätze.vue?vue&type=script&lang=js&"
import style0 from "./Umsätze.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports